export default "__VITE_ASSET__Cce_qjJW__"